<template>
  <w-setting-sliding-popup ref="slidingPopup" title="비밀번호 변경" width="500px" @close="close">
    <div slot="content">
      <el-form :rules="rules" :model="formData" ref="pwForm">
        <el-row>
          <el-form-item label="현재 비밀번호" prop="checkEncryptPwCheck">
            <el-input type="password" v-model="checkPassword"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="변경 비밀번호" prop="updateEncryptPw">
            <el-input type="password" v-model="updateEncryptPw"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="변경 비밀번호 확인" prop="updateEncryptPwCheck">
            <el-input type="password" v-model="updateEncryptPwCheck"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="solid" size="large" @click="onSavePassword">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import LmsApplogAPI from '@/api/settings/log/lms-applog-setting';
import msgUtil from '@/utils/message';
import rsaEncrypt from '@/utils/rsa-encrypt';

export default {
  name: 'WAppLogPwChangePopup',
  props: {
    formData: {
      type: Object,
    },
  },
  data() {
    const validatorCurrentPassword = (rule, value, callback) => {
      const fieldData = {
        encryptPw: this.checkPassword,
      };
      if (this.checkPwFlag()) {
        rsaEncrypt.getRsaEncrypt(fieldData).then((encryData) => {
          const params = {
            logInfo: {
              logId: this.formData.logInfo.logId,
              encryptPw: encryData.encryptPw,
            },
          };
          LmsApplogAPI.checkApplogPassword(params).then((response) => {
            if (!response.data.success) {
              callback(new Error('비밀번호가 맞지 않습니다'));
            } else {
              callback();
            }
          });
        }).catch((e) => {
          callback(new Error('비밀번호가 맞지 않습니다'));
          throw new Error(e);
        });
      } else {
        callback();
      }
    };
    const validatorPassword = (rule, value, callback) => {
      if (this.checkPwFlag()) {
        if (this.updateEncryptPwCheck !== this.updateEncryptPw) {
          callback(new Error('비밀번호를 확인하세요'));
        }
      }
      callback();
    };
    const validatorUpdatePassword = (rule, value, callback) => {
      if (isEmpty(this.updateEncryptPw)) {
        callback(new Error('변경할 비밀번호를 입력하세요'));
      } else {
        callback();
      }
    };
    return {
      updateEncryptPw: null,
      updateEncryptPwCheck: null,
      checkPassword: null,
      rules: {
        updateEncryptPwCheck: [
          { required: true, validator: validatorPassword, trigger: 'blur' },
        ],
        checkEncryptPwCheck: [
          { required: true, validator: validatorCurrentPassword, trigger: 'blur' },
        ],
        updateEncryptPw: [
          { required: true, validator: validatorUpdatePassword, trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    /**
     * 비밀번호 설정 여부 확인
     * @author leesy918
     * @return {[type]} [description]
     */
    checkPwFlag() {
      return this.formData.checkEncryptFlag === 'Y';
    },
    onSavePassword() {
      this.$refs.pwForm.validate().then((success) => {
        if (success) {
          const fieldData = {
            encryptPw: this.updateEncryptPw,
          };
          rsaEncrypt.getRsaEncrypt(fieldData).then((encryData) => {
            const params = {
              logTargetId: this.formData.applogId,
              objId: this.formData.logInfo.objId,
              logId: this.formData.logInfo.logId,
              encryptPw: encryData.encryptPw,
            };
            LmsApplogAPI.updateApplogPassword(params).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '비밀번호', true));
                this.formData.logInfo.encryptPw = this.updateEncryptPw;
                this.close();
              } else {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '비밀번호', false));
              }
            });
          }).catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '비밀번호', false));
            throw new Error(e);
          });
        }
      });
    },
    open() {
      this.$refs.slidingPopup.visible = true;
    },
    close() {
      this.$refs.pwForm.resetFields();
      this.updateEncryptPwCheck = null;
      this.checkPassword = null;
      this.updateEncryptPw = null;
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/Applog/popup/AppLogPwChangePopup.vue